export interface ISelectableButtonMenu {
  value: string | number;
  text: string;
  isDisabled?: boolean;
}

// 해당 컴포넌트는 common.scss에서 정의된 스타일을 사용합니다.
export default function SelectableButtonsGrid(props: {
  column: number;
  menus: ISelectableButtonMenu[];
  currentValue: string | number;
  onClickButton: (value: string | number) => void;
}) {
  return (
    <ul
      className={`
        selectable-buttons-grid
        items-${props.column}
      `}
    >
      {props.menus.map((item) => (
        <li
          key={`selectable-buttons-grid-${item.value}`}
          className={`
            ${props.currentValue === item.value ? "active" : ""}
            ${item.isDisabled ? "disabled" : ""}
          `}
          onClick={() => {
            if (item.isDisabled === true) {
              return;
            }
            props.onClickButton(item.value);
          }}
        >
          {item.text}
        </li>
      ))}
    </ul>
  );
}
